import { createPinia } from "pinia"
import { createApp } from "vue"
import { fetchCsrfToken } from "@/api/admin/client"
import App from "./App.vue"
import router from "./router"
import "./design-system/tokens.css"
import "./styles/main.scss"

const app = createApp(App)

const pinia = createPinia()
app.use(pinia)
app.use(router)
// CSRF di background - jangan tunda first paint; interceptor tetap bisa fetch jika kosong
void fetchCsrfToken()

app.mount("#app")
